"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeCompositeDesign;
const UserPhotoLayer_1 = require("../../models/layers/UserPhotoLayer");
const updatePrintableDesignLayers_1 = require("./updatePrintableDesignLayers");
const updatePrintableLayerZIndex_1 = require("../project/updatePrintableLayerZIndex");
const compareByReadingOrder_1 = __importDefault(require("./compareByReadingOrder"));
function makeCompositeDesign(activePage, oldLayers, newLayers, shiftedLayers, surface) {
  let combinedLayers = [];
  const cleanedShiftedLayers = shiftedLayers.map(l => (0, UserPhotoLayer_1.isUserPhotoLayer)(l) ? (0, UserPhotoLayer_1.clearUserPhotoLayer)(l) : l);
  if (activePage === 'right') {
    const leftPartialLayers = oldLayers.filter(l => !l.id.includes('--SHIFTED'));
    const rightPartialLayers = oldLayers.filter(l => l.id.includes('--SHIFTED'));
    const shiftedLayersWithUserData = (0, updatePrintableDesignLayers_1.updatePrintableDesignLayers)({
      oldSurface: surface,
      workspaceRotatedForPrintable: false,
      // we know the workspace is not rotated here because composite designs only apply to books and workspace rotation only applies to prints
      existingPrintableLayers: rightPartialLayers,
      newTemplateLayers: cleanedShiftedLayers,
      ignoreEditableTextTemplateLayers: true // we know this is an interior layflat printable because composite designs are not used with any other product, or in any other printable group
    });

    combinedLayers = [...(0, updatePrintableLayerZIndex_1.sortByZIndex)(leftPartialLayers), ...shiftedLayersWithUserData.sort(compareByReadingOrder_1.default)];
  } else if (activePage === 'left') {
    const rightPartialLayers = oldLayers.filter(l => l.id.includes('--SHIFTED'));
    combinedLayers = [...newLayers.sort(compareByReadingOrder_1.default), ...(0, updatePrintableLayerZIndex_1.sortByZIndex)(rightPartialLayers)];
  } else {
    combinedLayers = [...newLayers, ...cleanedShiftedLayers].sort(compareByReadingOrder_1.default);
  }
  return (0, updatePrintableLayerZIndex_1.ensureUniqueLayerZIndexes)(combinedLayers).sort(compareByReadingOrder_1.default);
}